import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageInteract = _resolveComponent("MessageInteract")!
  const _component_MessageHour = _resolveComponent("MessageHour")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative w-full rounded-md flex flex-wrap group", _ctx.state.position === 'sent' ? 'ml-[20%]' : 'mr-[20%]'])
  }, [
    _createElementVNode("div", {
      id: _ctx.state.uuid,
      class: _normalizeClass(["inline-block rounded-md text-sm text-neutral-600", _ctx.backgroundColor]),
      onMouseenter: _cache[0] || (_cache[0] = () => _ctx.onFocus = true),
      onMouseleave: _cache[1] || (_cache[1] = () => _ctx.onFocus = false)
    }, [
      _createVNode(_component_MessageInteract, {
        value: _ctx.state.uuid,
        focus: _ctx.onFocus,
        onOnUpdate: _ctx.handleClickInteract
      }, null, 8, ["value", "focus", "onOnUpdate"]),
      _createElementVNode("a", {
        title: "Clique para visualizar a imagem",
        href: _ctx.image,
        target: "_blank"
      }, [
        _createElementVNode("img", {
          src: _ctx.image,
          class: _normalizeClass(["rounded w-full", { 'rounded-b-none': _ctx.legend }]),
          alt: "imagem do chat"
        }, null, 10, _hoisted_3)
      ], 8, _hoisted_2),
      (_ctx.legend !== '')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "break-words",
            innerHTML: _ctx.formatMessage(_ctx.legend)
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ], 42, _hoisted_1),
    _createVNode(_component_MessageHour, {
      date: _ctx.state.date,
      "custom-class": _ctx.state.position === 'sent' ? 'justify-end' : null
    }, null, 8, ["date", "custom-class"])
  ], 2))
}